import _ from 'lodash';
import React, {useEffect, useState} from 'react';
import {getMe, Role, User} from '../../graphql/auth';
import {getRule} from './dynamicCanRules';

const cache: {[key: string]: boolean} = {};

export const getAltPermissions = (permission: string) => {
  const permissions = ['*', permission];
  const permissionParts = permission.split('.');

  if (permissionParts && permissionParts.length > 1) {
    let currentPermission = '';
    for (let i: number = 0; i < (permissionParts.length - 1); i++) {
      currentPermission += permissionParts[i] + '.';
      permissions.push(currentPermission + '*');
    }
  }

  return permissions;
};

export const checkUserPermission = (
  user: User,
  role?: string | string[],
  permission?: string | string[],
  data?: {},
  all: boolean = false,
) => {
  const checkAll = all;
  let checkPassed = false;

  if(!role && !permission) return true;

  const cacheKey = 'user[' + ((user)? user.id : 'guest')+']' +
    'all['+(checkAll)+']' +
    'roles['+role+']' +
    'permissions['+permission+']' +
    'data['+JSON.stringify(data)+']';

  if(cache.hasOwnProperty(cacheKey)){
    return cache[cacheKey];
  }

  //TODO: check if permission has been specifically revoked.

  if(role && user.roles) {
    const roles = (typeof role === 'string') ? [role] : role;
    const found = roles.some((checkUserRole: string) => {
      const roleFound = user.roles!.find((userRole: Role) => {
        return userRole.ident === checkUserRole;
      });
      return !!roleFound;
    });
    if (found) checkPassed = true;
  }

  if (permission && user && user.permissionIdents) {
    const permissions = (typeof permission === 'string') ? [permission] : permission;

    if (checkAll) {
      const results = permissions.map((eachPermission: string) => {
        const allPermissions = _.sortedUniq(['*'].concat(getAltPermissions(eachPermission)));
        return allPermissions.some((checkEachPermission: string) => {
          const rule = getRule(checkEachPermission);
          if (rule) {
            return rule(user, data);
          } else {
            const found = user && user.permissionIdents && user.permissionIdents.find((ident: string) => {
              return ident === checkEachPermission;
            });
            return !!found;
          }
        });
      });

      const failed = results.indexOf(false) !== -1;
      if(!failed) checkPassed = true;
    } else {
      const allPermissions = _.sortedUniq(['*'].concat(...permissions.map(getAltPermissions)));
      const result = allPermissions.some((checkEachPermission: string)=> {
        const rule = getRule(checkEachPermission);
        if(rule){
          return rule(user, data);
        } else {
          const found = user && user.permissionIdents && user.permissionIdents.find((ident: string) => {
            return ident === checkEachPermission;
          });
          return !!found;
        }
      });
      if(result) checkPassed = true;
    }
  }

  cache[cacheKey] = checkPassed;
  return checkPassed;
};

export const checkPermission = (
  permission?: string | string[],
  data?: {},
  all: boolean = false,
) => {
  const [passed, setPassed] = useState(false);
  const userData = getMe();

  useEffect(() => {
    if(userData.data) {
      setPassed(checkUserPermission(userData.data.me, undefined, permission, data, all));
    }
  });

  return passed;
};

export const checkRole = (
  role?: string | string[],
  data?: {},
  all: boolean = false,
) => {
  const [passed, setPassed] = useState(false);
  const userData = getMe();

  useEffect(() => {
    if (userData.data && userData.data.me) {
      //console.log('userData', userData);
      setPassed(checkUserPermission(userData.data.me, role, undefined, data, all));
    }
  });

  return passed;
};

export const CanPure = (props: {
  checkAll?: boolean,
  role?: string | string[],
  permission?: string | string[],
  data?: {},
  fail?: React.ComponentType<any>,
  children?: any,
  user: any,
  active: boolean,
  loading: boolean,
}) => {
  if(props.loading) return null;
  if(!props.active) return null;
  const allowed = checkUserPermission(props.user, props.role, props.permission, props.data, props.checkAll);
  if(!allowed) return props.fail? <props.fail /> : null;
  return props.children;
};

export const Can = (props: {
  checkAll?: boolean,
  role?: string | string[],
  permission?: string | string[],
  data?: {},
  fail?: React.ComponentType<any>,
  children?: any,
}) => {

  const userData = getMe();
  const active = !!(userData.data && userData.data.me);
  const loading = userData.loading;

  return <CanPure {...props} loading={loading} user={userData.data!.me} active={active} />;
};

export default Can;